import {
  defaultValidation,
  nameValidation,
  phoneNoValidation,
  emailValidation,
} from "utils/validators";
import * as Yup from "yup";

export const agentPersonalDetailsValidation = (showTIN, validateReferralCode) =>
  Yup.object({
    aggregator: Yup.string().required(`Select a registration type`),
    address: defaultValidation("Address"),
    localGovt: defaultValidation("Local Government"),
    region: defaultValidation("Region"),
    state: defaultValidation("State"),
    nearestBusStop: Yup.string().required(`Enter nearest bus stop`),
    identificationType: Yup.string().required(`Select an Identification type`),
    identificationNumber: defaultValidation("Identification Number"),
    corporate: Yup.string().required("Select an Option"),
    tin: showTIN && defaultValidation("Tax Identification Number"),
    corporateName: showTIN && defaultValidation("Corporate Name"),
    isPEP: Yup.string().required(`Select a status`),
    referredBy: Yup.string().required(`Select an option`),
    referralAgentCode: validateReferralCode && defaultValidation("Aggregator Code"),
  });

export const agentNOKValidation = Yup.object({
  email: emailValidation(),
  firstName: nameValidation("First Name", "firstName"),
  lastName: nameValidation("Last Name", "lastName"),
  phoneNumber: phoneNoValidation(),
  address: defaultValidation("Address", "address"),
  region: defaultValidation("Region", "region"),
  state: defaultValidation("State", "state"),
  gender: defaultValidation("Gender"),
  relationship: defaultValidation("Relationship"),
});

export const agentGuarantorDetailsValidation = (shouldValidate) =>
  shouldValidate
    ? Yup.object({
        email: emailValidation(),
        firstName: nameValidation("First Name", "firstName"),
        lastName: nameValidation("Last Name", "lastName"),
        phoneNumber: phoneNoValidation(),
        address: defaultValidation("Address", "address"),
        region: defaultValidation("Region", "region"),
        state: defaultValidation("State", "state"),
        gender: defaultValidation("Gender"),
        identificationType: Yup.string().required(
          `Select an Identification type`
        ),
        identificationNumber: defaultValidation("Identification Number"),
      })
    : Yup.object({
        email: Yup.string().email("Invalid email format!"),
      });

export const KYCDocumentsValidation = ({
  validateAgentId,
  validateUtilityBill,
  validateAgentPassport,
  validateFormC07,
}) =>
  Yup.object({
    utilityBill: validateUtilityBill && defaultValidation("Utility Bill"),
    agentIdentification: validateAgentId && defaultValidation("ID"),
    passport: validateAgentPassport && defaultValidation("Passport"),
    // guarantorIdentification: defaultValidation("Guarantor Identification"),
    // guarantorForm: defaultValidation("Guarantor Form"),
    // formC07: isCorporate && defaultValidation("Guarantor Form"),
    registrationProof: validateFormC07 && defaultValidation("Corporate’s form"),
  });
